import { v4 as uuidv4 } from 'uuid';
import {
  APPLICATION_JSON, CLIENT_ID, INCLUDE, POST,
} from '../constants/constants';
import { getBookingsServiceApiUrl } from '../selectors/selectors';

export default {
  fetch: ({
    data, segments, locale, correlationId,
  }, action, state) => ({
    url: `${getBookingsServiceApiUrl(state)}/booking/detail/preview`,
    opts: {
      method: POST,
      credentials: INCLUDE,
      headers: {
        Accept: APPLICATION_JSON,
        'Content-Type': APPLICATION_JSON,
        'x-correlation-id': correlationId || uuidv4(),
        'x-client-id': CLIENT_ID,
        'x-locale': locale,
      },
      body: JSON.stringify({
        pnr_number: data?.tripId,
        products: segments,
        booking_date: data?.booking_date,
        locale,
      }),
    },
  }),
};
